import React, { useCallback, useState } from 'react'
import ReactImageGallery from 'react-image-gallery'
import RenderMedia from '../Components/RenderMedia'

const ImageGalleryContainer = ({ images }) => {
    const [currentIndex, setCurrentIndex] = useState(0)

    const onSlide = (index) => {
        setCurrentIndex(index)
    }

    const renderMedia = useCallback(
        (item) => (
            <div style={{height: '100%'}}>
                <RenderMedia
                    item={item}
                    currentIndex={currentIndex}
                />
            </div>
        ),
        [currentIndex]
    )

    return (
        <ReactImageGallery
            items={images}
            renderItem={renderMedia}
            onSlide={onSlide}
            showThumbnails={false}
            showPlayButton={false}
            showBullets={true}
            showFullscreenButton={false}
            showNav={true}
        />
    )
}

export default ImageGalleryContainer
